export const API = process.env.REACT_APP_API_URL || 'https://corgifonline.com';
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'https://corgifonline.com';

export const authHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
  'Content-Type': 'application/json'
});

export const authHeadersOnly = () => ({
  'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
});
